import React, { useState, useCallback, useEffect } from 'react';
import './styles.scss';
import './radix-dropdown.scss';
import logoWhite from './hp-white.svg';
import { Button, Icons } from '@hyperping/design';
import RightArrow from '../../v3/Hero/right-arrow.svg';
import { getUserCountry } from '../../../utils/ipinfo';
import { buildRegisterUrl } from '../../../utils';

const ProductsDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isHoveringDropdown, setIsHoveringDropdown] = useState(false);

  const handleMouseEnter = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setTimeout(() => {
      setIsOpen(false);
    }, 0);
  }, []);

  const handleDropdownMouseEnter = () => {
    setIsHoveringDropdown(true);
  };

  const handleDropdownMouseLeave = () => {
    if (isOpen) return;
    setIsHoveringDropdown(false);
    setIsOpen(false);
  };

  return (
    <div
      style={{ position: 'relative' }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        style={{ height: '66px',marginRight:'16px' }}
        className="flex align-items-center header-link mobile gap-035em cursor-pointer color-white"
      >
        Products
        <Icons size="small" name="chevrondown" className={`chevron-icon ${isOpen ? 'rotate' : ''}`} />
      </div>
      {isOpen && (
        <div
          className="products-dropdown"
          onMouseEnter={handleDropdownMouseEnter}
          onMouseLeave={handleDropdownMouseLeave}
        >
          <a href="/uptime-monitoring" className="product-nav-link flex align-items-center font-size-14px gap-075em">
            <div className="product-nav-link-icon"><Icons name="globe" /></div>
            <div className="flex flex-direction-column gap-035em">
              <div className="pnl-heading">Uptime Monitoring</div>
              <div className="pnl-text">HTTP, ICMP, Port, SSL, text assertion</div>
            </div>
          </a>
          
          <a href="/synthetic-monitoring" className="product-nav-link flex align-items-center font-size-14px gap-075em">
            <div className="product-nav-link-icon"><Icons name="cpu" /></div>
            <div className="flex flex-direction-column gap-035em">
              <div className="pnl-heading">Browser Checks</div>
              <div className="pnl-text">E2E tests with Playwright</div>
            </div>
          </a>
          
          <a href="/cron-job-monitoring" className="product-nav-link flex align-items-center font-size-14px gap-075em">
            <div className="product-nav-link-icon"><Icons name="heartbeat" /></div>
            <div className="flex flex-direction-column gap-035em">
              <div className="pnl-heading">Cron Monitoring</div>
              <div className="pnl-text">Cron jobs and other periodic processes</div>
            </div>
          </a>
          
          <a href="/status-page" className="product-nav-link flex align-items-center font-size-14px gap-075em">
            <div className="product-nav-link-icon"><Icons name="megaphone" /></div>
            <div className="flex flex-direction-column gap-035em">
              <div className="pnl-heading">Status Page</div>
              <div className="pnl-text">Communicate service status and incidents to users</div>
            </div>
          </a>
          
          <a href="/on-call" className="product-nav-link flex align-items-center font-size-14px gap-075em">
            <div className="product-nav-link-icon"><Icons name="calendar" /></div>
            <div className="flex flex-direction-column gap-035em">
              <div className="pnl-heading">On-Call</div>
              <div className="pnl-text">On-call schedules and incident response</div>
            </div>
          </a>

        </div>
      )}
    </div>
  );
};

const CustomersDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isHoveringDropdown, setIsHoveringDropdown] = useState(false);

  const handleMouseEnter = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setTimeout(() => {
      setIsOpen(false);
    }, 0);
  }, []);

  const handleDropdownMouseEnter = () => {
    setIsHoveringDropdown(true);
  };

  const handleDropdownMouseLeave = () => {
    if (isOpen) return;
    setIsHoveringDropdown(false);
    setIsOpen(false);
  };

  return (
    <div
      style={{ position: 'relative' }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        style={{ height: '66px', marginRight: '16px' }}
        className="flex align-items-center header-link mobile gap-035em cursor-pointer color-white"
      >
        Customers
        <Icons size="small" name="chevrondown" className={`chevron-icon ${isOpen ? 'rotate' : ''}`} />
      </div>
      {isOpen && (
        <div
          className="products-dropdown"
          onMouseEnter={handleDropdownMouseEnter}
          onMouseLeave={handleDropdownMouseLeave}
        >
          <a href="/customers" className="product-nav-link flex align-items-center font-size-14px gap-075em">
            <div className="product-nav-link-icon"><Icons name="users" /></div>
            <div className="flex flex-direction-column gap-035em">
              <div className="pnl-heading">Customer Highlights</div>
              <div className="pnl-text">Case studies and testimonials</div>
            </div>
          </a>
          
          <a href="/customers/showcase" className="product-nav-link flex align-items-center font-size-14px gap-075em">
            <div className="product-nav-link-icon"><Icons name="medal" /></div>
            <div className="flex flex-direction-column gap-035em">
              <div className="pnl-heading">Customer Showcase</div>
              <div className="pnl-text">Featured customer status pages</div>
            </div>
          </a>
        </div>
      )}
    </div>
  );
};

const Header = ({ isBlogPage, isBlogArticle, cta = 'Sign up' }) => {
  const [isScrollTop, setIsScrollTop] = React.useState(true);
  const [isFrenchUser, setIsFrenchUser] = React.useState(false);
  const [registerUrl, setRegisterUrl] = React.useState('https://app.hyperping.io/register');
  
  // Effect for scroll detection
  React.useEffect(() => {
    const onScroll = e => {
      setIsScrollTop(e.target.documentElement.scrollTop === 0);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  
  // Effect for cookies, path detection, and user country detection
  React.useEffect(() => {
    // Update register URL with UTM parameters after component mounts
    setRegisterUrl(buildRegisterUrl());
    
    // Detect if user is from France
    getUserCountry((country) => {
      if (country === 'FR') {
        setIsFrenchUser(true);
      }
    });
  }, []);

  return (
    <div className={`header-sticky-wrapper ${isScrollTop ? 'scroll-top' : ''} ${isBlogPage ? 'in-blog' : ''} ${isBlogArticle ? 'in-blog-article' : ''}`}>
      <header className="header-sticky">
        <nav className="header-nav">
          <div className="flex align-items-center">
            <a href="/" className="header-logo mr-3em">
              <img height="28px" src={logoWhite} />
            </a>
            <ProductsDropdown />
            <CustomersDropdown />
            <a className="header-link mobile" href="/features">Features</a>
            <a className="header-link mobile" href="/docs">Docs</a>
            <a className="header-link mobile" href="/blog">Blog</a>
            <a className="header-link" href="/pricing">Pricing</a>
          </div>
          <div className="flex align-items-center">
            <a className="header-link" href="/contact/sales">
              {isFrenchUser ? 'Prendre rendez-vous 🇫🇷' : 'Contact Sales'}
            </a>
            <a className="header-link login-link" target="_blank" href="https://app.hyperping.io/login">Log in</a>
            <a className="header-link signup-link plausible-event-name=Signup+attempt" target="_blank" href={registerUrl}><Button>{cta} <img src={RightArrow} style={{marginTop:'1px'}} /></Button></a>
          </div>
        </nav>
      </header>
    </div>
  );
};

export default Header;
